export default __webpack_public_path__ + "static/media/icon_share-this-facebook.7128c6f4.svg";